module.exports = __webpack_public_path__ + "img/sigline.7935bb8c.png";